<template>
  <div>
    <ConfirmationToEditModal />
  </div>
</template>

<script>
import ConfirmationToEditModal from '../../components/organisms/ConfirmationToEditModal/ConfirmationToEditModal.vue'

export default {
  name: 'ConfirmationToEditView',
  components: {
    ConfirmationToEditModal
  }
}
</script>
